import { pushToDataLayer } from '@domain-group/fe-helper';
import { sendToMixpanel, getUserProps } from '..';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';

export const CONTENT_CAROUSEL_ELEMENT_TYPE = 'Widget';

export interface ContentCarouselItem {
  carouselName: string;
  carouselTitle: string;
  carouselSubTitle?: string;
  articleId?: string;
  articleTags?: string;
  articleTitle: string;
  position?: number;
  modules?: FaaLandingPageModule[];
}

const trackContentCarouselItem = ({
  carouselName,
  carouselTitle,
  carouselSubTitle = '',
  articleId = '',
  articleTags = '',
  articleTitle,
  position,
  modules = getVisibleLandingPageModules(),
}: ContentCarouselItem): void => {
  sendToMixpanel('Tap Content Carousel Item', {
    siteSection: 'Agents',
    carouselName,
    carouselTitle,
    carouselSubTitle,
    articleId,
    articleTags,
    articleTitle,
    modules,
    modulesCount: modules.length,
    ...getUserProps(),
  });

  pushToDataLayer({
    event: 'select_content',
    event_parameters: {
      element_list_name: carouselName,
      element_title: carouselTitle,
      element_text: articleTitle,
      ...(position === undefined ? {} : { element_list_position: position }),
      element_type: CONTENT_CAROUSEL_ELEMENT_TYPE,
    },
  });
};

export default trackContentCarouselItem;
